import { makeStyles } from "@material-ui/core/styles";

const useCustomStyles = makeStyles(() => ({
  severityBlock: {
    display: "flex",
    alignItems: "center",
    paddingLeft: ".5em",
    gap: "8px",
  },
  severityIndicator: {
    width: "12px",
    height: "12px",
    borderRadius: "2px",
  },
  customWarning: {
    backgroundColor: "#a69e9e",
  },
  customInfo: {
    backgroundColor: "#2196F3",
  },
  customNormal: {
    backgroundColor: "#2196F3",
  },
  customHigh: {
    backgroundColor: "#f44336",
  },
  customDangerous: {
    backgroundColor: "#f44336",
  },
  customGood: {
    backgroundColor: "#04b32f",
  },
  customUnknown: {
    backgroundColor: "#fff",
    border: "1px solid #333",
  },
  customSignature: {
    backgroundColor: "#a69e9e",
  },
  listTitle: {
    "& span": {
      background: "#eee",
      padding: ".2em 0.4em",
      border: "1px solid #ccc",
      margin: "0 1em 0 0",
      fontWeight: "400",
      lineHeight: "2.2em",
    },
  },
  cardTitle: {
    marginTop: "0",
    minHeight: "auto",
    fontWeight: "400",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    color: "#fefefe",
  },
}));

export default useCustomStyles;
